import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './login.component.html'
})
export class LoginComponent {
  form: FormGroup;
  loginError = false;
  loggingIn = false;

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private router: Router) {
    this.form = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });

    authService.isLoggedIn()
      .subscribe(isLoggedIn => {
        if (isLoggedIn) {
          this.router.navigateByUrl('/');
        }
      })
  }

  login() {
    this.loggingIn = true;
    const val = this.form.value;

    if (val.email && val.password) {
      this.authService.login(val.email, val.password)
        .subscribe({
          next: x => {
            console.log("User is logged in");
            this.router.navigate(['']);
          },
          error: err => {
            this.loginError = true;
            this.form.markAsUntouched();
            this.loggingIn = false;
          }
        });
    }
    else {
      this.loggingIn = false;
    }
  }
}
